
import React, { useState, useEffect } from 'react';
import { TrendingUp, MapPin } from 'lucide-react';

const activities = [
  { name: "Mike in Raleigh", action: "just booked 3 estimates", time: "2 mins ago" },
  { name: "Sarah in Austin", action: "generated $8,400 this week", time: "15 mins ago" },
  { name: "Joe's Tree Care", action: "closed a $4,200 removal", time: "1 hour ago" },
  { name: "Chris in Columbus", action: "added 12 jobs to pipeline", time: "4 mins ago" }
];

const SocialProofWidget: React.FC = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showTimer = setInterval(() => {
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
      setIndex((prev) => (prev + 1) % activities.length);
    }, 12000);

    return () => clearInterval(showTimer);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:right-auto md:bottom-8 md:left-8 z-[100] animate-in slide-in-from-left-full duration-500">
      <div className="bg-[#0F1419]/90 backdrop-blur-xl border-2 border-[#1A4D2E] p-4 rounded-2xl shadow-2xl flex items-center gap-4 max-w-sm mx-auto md:mx-0">
        <div className="w-12 h-12 bg-[#1A4D2E] rounded-xl flex items-center justify-center flex-shrink-0">
          <TrendingUp className="w-6 h-6 text-[#FF6B35]" />
        </div>
        <div>
          <p className="text-white text-sm font-black uppercase tracking-tight italic leading-tight">
            {activities[index].name} <span className="text-gray-400 not-italic lowercase font-bold font-sans tracking-normal block md:inline">{activities[index].action}</span>
          </p>
          <div className="flex items-center gap-2 mt-1">
            <MapPin className="w-3 h-3 text-[#FF6B35]" />
            <span className="text-[10px] text-gray-500 font-black uppercase tracking-widest">{activities[index].time}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProofWidget;
